export { default as useMediaQuery } from './useMediaQuery';
export * from './useMediaQuery';
//# sourceMappingURL=index.js.map